// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2bi5l","header":"ClearentDisclaimer_header__3B5gD","inner":"ClearentDisclaimer_inner__3lTdy"};